// extracted by mini-css-extract-plugin
export default {"medicinesContainer":"DayAdminDialog_medicinesContainer__0SfjV","horizontalLine":"DayAdminDialog_horizontalLine__Xmy+X"};